// RenderRoutes.tsx
import React from "react";
import { Navigate, Route } from "react-router-dom";
import CommonContainer from "../../components/commonContainer/CommonContainer";

export const renderRoutes = (routes: any[], parentKey = "") =>
  routes?.map((route, i) => {
    const key = `${parentKey}${i}`;
    if (route?.SUBNAV?.length > 0) {
      if (route?.DIRECT) {
        return (
          <Route
            key={key}
            path={route.PATH}
            element={
              <CommonContainer SUBNAV={route.SUBNAV} TITLE={route.TITLE} />
            }
          >
            <Route
              path={route.PATH}
              element={<Navigate to={route?.SUBNAV[0].PATH} />}
            />
            {renderRoutes(route.SUBNAV, `${key}-`)}
          </Route>
        );
      } else {
        return route.SUBNAV.map((subRoute: any, j: number) => {
          const subKey = `${key}-${j}`;
          if (subRoute?.SUBSUBNAV?.length > 0) {
            return (
              <Route
                key={subKey}
                path={subRoute.PATH}
                element={
                  <CommonContainer
                    SUBNAV={subRoute.SUBSUBNAV}
                    TITLE={subRoute.TITLE}
                  />
                }
              >
                <Route
                  path={subRoute.PATH}
                  element={<Navigate to={subRoute?.SUBSUBNAV[0].PATH} />}
                />
                {renderRoutes(subRoute.SUBSUBNAV, `${subKey}-`)}
              </Route>
            );
          }
          return (
            <Route
              key={subKey}
              path={subRoute.PATH}
              element={<subRoute.ELEMENT />}
            />
          );
        });
      }
    }

    return <Route key={key} path={route.PATH} element={<route.ELEMENT />} />;
  });
